// Флаг «пользователь видел вводные экраны». Живёт на устройстве (localStorage),
// как recipt-auth / recipt-billing-pending. На новом устройстве онбординг покажется снова — это приемлемо.
const KEY = 'recipt-onboarding-done';

/** Пройден ли онбординг. При недоступном localStorage (приватный режим) → true, чтобы не навязываться повторно. */
export function isOnboardingDone(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return true;
  }
}

/** Пометить онбординг пройденным. Ошибку записи (приватный режим) глотаем — не критично. */
export function markOnboardingDone(): void {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    // localStorage недоступен — молча игнорируем
  }
}
